import { ClientSubscription } from '@/models/Client';
import { SubscriptionPayment } from '@/hooks/clients/useSubscriptionPayments';

export const calculateSubscriptionPaymentInfo = (
  subscription: ClientSubscription,
  subscriptionPayments: SubscriptionPayment[]
) => {
  // Filter payments for current cycle
  const currentCyclePayments = subscriptionPayments.filter(payment => {
    const paymentDate = new Date(payment.payment_date);
    const cycleStartDate = new Date(subscription.currentCycleStartDate);
    return paymentDate >= cycleStartDate;
  });

  const totalPaid = currentCyclePayments.reduce((sum, payment) => sum + payment.amount, 0);
  const remainingAmount = Math.max(0, subscription.price - totalPaid);
  const isPaid = totalPaid >= subscription.price;
  const isPartial = totalPaid > 0 && totalPaid < subscription.price;

  return {
    totalPaid,
    remainingAmount,
    isPaid,
    isPartial,
    currentCyclePayments
  };
};